// Example: Meat, spice, vegetables
enum FoodType {
  Meat,
  Spice,
  Veg,
  Carb,
}

export default FoodType
